// État partagé (en mémoire, PAS sessionStorage) entre PrivateRoute — qui l'utilise pour ne
// déclencher la reprise d'un parcours Premium en attente de paiement qu'une fois par
// chargement de page — et AuthContext — qui le réinitialise à chaque déconnexion.
//
// Module dédié plutôt qu'une variable interne à PrivateRoute.tsx, pour éviter un import
// circulaire avec AuthContext.tsx (PrivateRoute importe déjà useAuth depuis AuthContext).
//
// La réinitialisation doit se faire depuis AuthContext.logout() — le point de passage
// unique et garanti de toute déconnexion — plutôt que depuis un effet React observant la
// transition isAuthenticated dans PrivateRoute : certains écrans (ex. BoardAdmin) appellent
// navigate('/login') juste après logout(), ce qui regroupe le changement d'auth et le
// changement de route dans un seul rendu React — l'instance PrivateRoute de l'ancienne
// route est alors démontée sans jamais être re-rendue avec juste isAuthenticated=false, et
// un effet local n'a donc pas l'occasion de s'exécuter.
let hasCheckedPendingPremiumThisPageLoad = false;

export const hasCheckedPendingPremium = (): boolean => hasCheckedPendingPremiumThisPageLoad;

export const markPendingPremiumChecked = (): void => {
  hasCheckedPendingPremiumThisPageLoad = true;
};

export const resetPendingPremiumCheck = (): void => {
  hasCheckedPendingPremiumThisPageLoad = false;
};
